import React, { Component } from "react";
import "./audio-management.scss";
import { connect } from "react-redux";
import { Col, FormControl, FormGroup, Glyphicon, Grid, InputGroup, Row } from "react-bootstrap";
import Table from "../../lib/tables";
import {
  EpisodesByShowActionManager,
  ShowsForUserActionManager,
} from "../../../action_managers/shows";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import filter from "lodash/filter";
import partial from "lodash/partial";
import BaseModal from "../../modals/base_modal";
import forwardChevron from "../../../icons/forward-chevron.svg";
import { Link } from "react-router-dom";
import { showModal } from "../../../actions/modal";
import { SET_EPISODE_MARKERS_MODAL } from "../../modals/modal_root";

class MarkersChooseEpisodeModal extends Component {
  state = {
    showUUID: "",
    searchString: "",
  };

  componentDidMount() {
    this.props.fetchShowsForUser(this.props.user).then(resp => {
      if (resp.status === 200) {
        let shows = resp.json && resp.json.filter(show => show.isVisible);
        if (shows.length > 0) {
          const showUUID = shows[0].uuid;
          this.props.fetchEpisodesForShow(showUUID, this.props.user).then(() => {
            this.setState({ showUUID: showUUID });
          });
        }
      }
    });
  }

  filterEpisodes = e => {
    const substring = e.target.value.toLowerCase();
    this.setState({ searchString: substring });
  };

  selectShow = e => {
    const showUUID = e.target.value;
    this.props.fetchEpisodesForShow(showUUID, this.props.user).then(() => {
      this.setState({ showUUID: showUUID });
    });
  };

  columns = [
    {
      accessor: "episode",
      Cell: function Cell(a) {
        const episodeTitle = a.value.title;
        const imageURL = a.value.imageURL;

        return (
          <Link style={{ color: "black" }} to={`/insertion-points/episodes/${a.value.uuid}`}>
            <div className="flex-row-container markers-choose-modal__row">
              <img src={`${imageURL}?d=100x100`} className="album-art" alt="album-art" />
              <div className="markers-choose-modal__episode-title bold">{episodeTitle}</div>
              <img
                alt="chevron"
                src={forwardChevron}
                className="markers-choose-modal__chevron--right"
              />
            </div>
          </Link>
        );
      },
    },
  ];

  renderEpisodesList = () => {
    const show = get(this.props.showsByUUID, this.state.showUUID, {});
    const showImageURL = get(show, "imageURL");
    const episodes = get(this.props.episodesByShowUUID, [this.state.showUUID, "episodes"], {});
    const filteredEpisodes = filter(episodes, episode => {
      return episode.title.toLowerCase().includes(this.state.searchString);
    });

    const data = filteredEpisodes.map(episode => {
      episode.imageURL = !isEmpty(episode.imageURL) ? episode.imageURL : showImageURL;

      return {
        episode: episode,
      };
    });

    return (
      <Table
        getTheadProps={() => ({
          style: {
            display: "none",
          },
        })}
        className="padding-bottom--large"
        style={{ maxHeight: "59vh" }}
        data={data}
        columns={this.columns}
      />
    );
  };

  renderBody = () => {
    const showOptions = this.props.shows
      .filter(show => {
        return show.isVisible;
      })
      .map(show => {
        return (
          <option key={show.uuid} value={show.uuid}>
            {show.title}
          </option>
        );
      });

    return (
      <Grid fluid>
        <Row>
          <Col xs={12}>
            <br />
            <FormGroup>
              <FormControl
                componentClass="select"
                placeholder="select show"
                value={this.state.showUUID}
                onChange={this.selectShow}>
                {showOptions}
              </FormControl>
            </FormGroup>
            <div>Select which episode you'd like to add or edit insertion points</div>
            <br />
            <FormGroup>
              <InputGroup>
                <InputGroup.Addon style={{ backgroundColor: "inherit" }}>
                  <Glyphicon glyph="search" />
                </InputGroup.Addon>
                <FormControl
                  type="text"
                  placeholder="Filter Episodes"
                  onChange={this.filterEpisodes}
                />
              </InputGroup>
            </FormGroup>
            {this.renderEpisodesList()}
          </Col>
        </Row>
      </Grid>
    );
  };

  render() {
    const { hideModal } = this.props;
    return (
      <BaseModal
        title="Choose an episode"
        Content={this.renderBody}
        close={hideModal}
        showContent={true}
        hideFooter={true}
        columns={12}
        offset={0}
      />
    );
  }
}

export default connect(
  state => {
    const shows = state.shows.shows || {};
    return {
      episodesByShowUUID: state.episodesByShow,
      shows: Object.keys(shows).map(key => shows[key]),
      showsByUUID: shows,
      user: state.user.user,
    };
  },
  {
    showModal: partial(showModal, SET_EPISODE_MARKERS_MODAL),
    fetchShowsForUser: user => new ShowsForUserActionManager({ user }).run(),
    fetchEpisodesForShow: (showUUID, user) => {
      return new EpisodesByShowActionManager({ showUUID, user }).run();
    },
  }
)(MarkersChooseEpisodeModal);
